import { createSlice } from '@reduxjs/toolkit';
import { UploadFile } from 'antd';

interface TaskFiles {
  file: UploadFile;
  filePath?: string;
}

interface ToolConfigState {
  uploadToolFilePaths: {
    [taskId: string]: TaskFiles[];
  };
}

const initialState: ToolConfigState = {
  uploadToolFilePaths: {},
};

const uploadToolSlice = createSlice({
  name: 'toolConfig',
  initialState,
  reducers: {
    setTaskFilePaths(state, action) {
      const { taskId, files } = action.payload;
      state.uploadToolFilePaths[taskId] = files;
    },
    addTaskFile(state, action) {
      const { taskId, file, filePath = "" } = action.payload;
      if (!state.uploadToolFilePaths[taskId]) {
        state.uploadToolFilePaths[taskId] = [];
      }
      // Check for duplicates before adding
      const exists = state.uploadToolFilePaths[taskId].some(
        (f) => f.file.name === file.name
      );
      if (!exists) {
        state.uploadToolFilePaths[taskId].push({ file, filePath });
      }
    },
    removeTaskFile(state, action) {
      const { taskId, fileName } = action.payload;
      if (state.uploadToolFilePaths[taskId]) {
        state.uploadToolFilePaths[taskId] = state.uploadToolFilePaths[taskId].filter(
          (f) => f.file.name !== fileName
        );
      }
    },
    resetUploadFiles(state) {
      state.uploadToolFilePaths = {};
    },
  },
});

export const { setTaskFilePaths, addTaskFile, removeTaskFile, resetUploadFiles } = uploadToolSlice.actions;
export default uploadToolSlice.reducer;
